import combineURLs from 'axios/lib/helpers/combineURLs';
import api from 'utils/api';
import { extractTransformersUidFromMediaKey } from './media.utils';

const acceptAnyStatus = () => true;

const isSuccessStatus = (status) => status >= 200 && status < 300;

/**
 * GET {url} and return the HTTP status, or null on network failure.
 * Uses GET (not HEAD): transformers CORS allows GET but not HEAD.
 */
const probeTransformersUrlStatus = async (url) => {
  try {
    const response = await api.request({
      method: 'GET',
      url,
      validateStatus: acceptAnyStatus,
      responseType: 'arraybuffer',
      transformResponse: [() => null],
    });
    return response.status;
  } catch {
    return null;
  }
};

/**
 * Returns true when transformers serves a Readium manifest at {mediaKey}manifest.json.
 * LCP EPUBs return 2xx; LCP PDFs reject that path (400) or error when no manifest exists.
 */
export const probeTransformersManifest = async (mediaKey) => {
  if (!mediaKey) {
    return false;
  }

  const url = combineURLs(mediaKey, 'manifest.json');
  const status = await probeTransformersUrlStatus(url);
  return isSuccessStatus(status);
};

/**
 * Returns true when transformers serves a PDF at {mediaKey}{uuid}.pdf.
 */
export const probeTransformersPdf = async (mediaKey) => {
  const uuid = extractTransformersUidFromMediaKey(mediaKey);
  if (!uuid || !mediaKey) {
    return false;
  }

  const url = combineURLs(mediaKey, `${uuid}.pdf`);
  const status = await probeTransformersUrlStatus(url);
  return isSuccessStatus(status);
};
